import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import parseResponseToOptions, {
  parseUserListOptions,
  parseVMCitiesOptions
} from '../../utils/parseResponseToOptions';
import AssignVMUserComponent from './component';

class AssignUserMFContainer extends Component {
  constructor() {
    super();
    this.state = {
      userId: null,
      mfgId: [],
      userList: [],
      mfList: [],
      loading: true,
      userLoading: true,
      mfLoading: true
    };
  }
  componentDidMount() {
    this.props.getDataFromAPI(
      '/manufacturers/list/names',
      'GET',
      undefined,
      response => {
        this.setState({ mfList: parseResponseToOptions(response.list), mfLoading: false });
        this.setState({ loading: false });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch manufacturer details');
        this.setState({ loading: false, mfLoading: false });
      }
    );

    this.props.getDataFromAPI(
      '/users/list',
      'GET',
      undefined,
      response => {
        this.setState({ userList: parseUserListOptions(response.list), userLoading: false });
        this.setState({ loading: false });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch manufacturer details');
        this.setState({ loading: false, userLoading: false });
      }
    );
  }

  onChangeOfUser = (event, data) => {
    this.setState({ userId: data.value });
  };

  onChangeOfMF = (event, data) => {
    this.setState({ mfgId: data.value });
  };

  handleSubmit = () => {
    // set loading true
    this.setState({ loading: true });

    const { userId, mfgId } = this.state;

    const payload = {
      userId,
      mfgId
    };

    if (!userId) {
      this.setState({ loading: false });
      return toastr.error('Invalid', 'Please select user');
    }
    if (!mfgId.length) {
      this.setState({ loading: false });
      return toastr.error('Invalid', 'Please select a MF');
    }

    this.props.getDataFromAPI(
      '/users/mfg',
      'POST',
      payload,
      response => {
        toastr.success('Successful', `Assigned ${mfgId.length} to user`);
        this.setState({ loading: false });
        return this.props.history.push('/users/list');
      },
      err => {
        this.setState({ loading: false });
        toastr.error('Failed', 'Failed to assign MF to user');
      }
    );
  };

  render() {
    return (
      <AssignVMUserComponent
        onChangeOfUser={this.onChangeOfUser}
        onChangeOfMF={this.onChangeOfMF}
        submitting={this.state.loading}
        dropdownLoading={this.state.loading}
        handleSubmit={this.handleSubmit}
        mfLoading={this.state.mfLoading}
        userLoading={this.state.userLoading}
        mfList={this.state.mfList}
        userList={this.state.userList}
      />
    );
  }
}

export default withRouter(
  connect(null, {
    getDataFromAPI
  })(AssignUserMFContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/UsersAssignMF/container.jsx